import {getContext, store} from '@wordpress/interactivity';

store('wpbs/team-profile', {

    state: {
        isOpen: false,
    },
    actions: {
        async toggle() {

            const {state} = store('wpbs/team-profile');
            const context = getContext();
            const id = context?.postId;

            if (!id) return;


            const args = {
                postId: parseInt(id),
            };

            const rendered = (await WPBS.render.request('team', 'profile', args))?.rendered;

            if (!rendered) return;

            WPBS.modals.toggle_modal(false, {
                template: rendered,
            });
        },
    },
});